import type { DateRangeOption } from '@/interfaces/api/analytics';

export const NODE_ENV = import.meta.env.VITE_NODE_ENV;

export const API_URL =
  NODE_ENV === 'development' ? import.meta.env.VITE_DEV_API : import.meta.env.VITE_PROD_API;

export const SITE_URL =
  NODE_ENV === 'development' ? import.meta.env.VITE_DEV_DOMAIN : import.meta.env.VITE_PROD_DOMAIN;

export const PUBLIC_SITE_URL =
  (NODE_ENV === 'development'
    ? import.meta.env.VITE_DEV_PUBLIC_DOMAIN
    : import.meta.env.VITE_PROD_PUBLIC_DOMAIN) ?? SITE_URL;

export const dateRangeOptions: DateRangeOption[] = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
];
